import { render, staticRenderFns } from "./batch_import.vue?vue&type=template&id=f4c5128a"
import script from "./batch_import.vue?vue&type=script&lang=js"
export * from "./batch_import.vue?vue&type=script&lang=js"
import style0 from "./batch_import.vue?vue&type=style&index=0&id=f4c5128a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports